import { VolumeType } from '@/consts/machine'

export interface StorageBillingMode {
  imageOnSpaceBilling: boolean
  snapshotOnSpaceBilling: boolean
}

export function getStorageBillingMode(
  volumes: readonly { type: number }[] | null | undefined,
): StorageBillingMode {
  const list = volumes || []
  return {
    imageOnSpaceBilling: list.some((v) => v.type === VolumeType.Image),
    snapshotOnSpaceBilling: list.some((v) => v.type === VolumeType.Snapshot),
  }
}

/**
 * Entry point for the user-initiated "switch to time-based billing" flow.
 * Disabled because the migration is now performed by the backend for every
 * account; set to true to bring the banner and its modal back.
 */
export const BILLING_SWITCH_ENTRY_ENABLED = false

export const SWITCH_RESUMABLE_POLL_INTERVAL_MS = 5000
export const SWITCH_RESUMABLE_POLL_WINDOW_MS = 60000

const SWITCH_COMPLETED_AT_KEY = 'storageBillingSwitchCompletedAt'

export function markBillingSwitchCompleted() {
  try {
    sessionStorage.setItem(SWITCH_COMPLETED_AT_KEY, String(Date.now()))
  } catch {
    return
  }
}

export function getBillingSwitchCompletedAt(): number | null {
  try {
    const raw = sessionStorage.getItem(SWITCH_COMPLETED_AT_KEY)
    const value = raw ? Number(raw) : NaN
    return Number.isFinite(value) ? value : null
  } catch {
    return null
  }
}
